import { Component, OnInit, ViewChild, Input, ElementRef, HostListener } from '@angular/core';
import { TitleConfigurations, TitleLineConfigurations } from '../title/title.configurations';
import { RingGraphConfigurations } from './ring-graph-model';
import { NewsConfigurations } from "../news/news.configurations";
import { KlaHttpService } from '../services/kla.http.service';
import { CommonModule } from '@angular/common';
import { RingChartComponent } from 'app/shared/charts/ring-chart/ring-chart.component';
import { TitleComponent } from '../title/title.component';
import { NewsComponent } from '../news/news.component';
import { SafeHtmlPipe } from '../safe-html/safe-html';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

@Component({
  selector: 'kla-ring-graph',
  templateUrl: './ring-graph.component.html',
  styleUrls: ['./ring-graph.component.scss'],
  standalone: true,
  imports: [ CommonModule, RingChartComponent, TitleComponent, NewsComponent, DynamicContentComponent ]
})
export class RingGraphComponent implements OnInit {

  @ViewChild('panel', {static: true})
  public panel:ElementRef;

  @Input()
  public chartConfig: RingGraphConfigurations;

  @Input()
  public config: {
    image:string,
    title: TitleConfigurations,
    chartId: string,
    newsId: string,
  };

  @Input()
  public lineConfig: TitleLineConfigurations;

  public listOfNews: Array<NewsConfigurations> = [];

  constructor(private http: KlaHttpService) {
    this.chartConfig = {
      id : "_" + Math.random().toString(36).substr(2, 9),
      width: 488,
      height: 468,
      thickness: 30,
      image:"",
      data: null
    }
  }
  ngOnInit() {
    this.http.getChartData("kla-ring", this.config.chartId).subscribe(
      (data) => {
        this.chartConfig.data = data ? data.items : undefined;
        if (!this.chartConfig.data) {
          console.error("Please provide bar chart configurations");
        } else {
          this.resize();
        }
      },
      (err) => {
        console.error(err);
      }
    );
    this.onResize();
    this.findNews();
  }

  @HostListener('window:resize')
  onResize() {
    this.resize();
  }
  private resize() {
    let rectangle = this.panel.nativeElement.getBoundingClientRect();

    if(rectangle.width < 607){
      this.chartConfig.width = 487;
    }

    if(rectangle.width > 488){
      this.chartConfig.width = 488;
    }else if(rectangle.width > 344 && rectangle.width < 488){
      this.chartConfig.width = rectangle.width;
    }else if(rectangle.width < 345){
      this.chartConfig.width = 345;
    }
  }

  private findNews() {
    this.http.getNewsData(this.config.newsId).subscribe(
      (data) => {
        this.listOfNews = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }
}
